import { render } from "./PermissonCard.vue?vue&type=template&id=37b3bebe"
import script from "./PermissonCard.vue?vue&type=script&lang=js"
export * from "./PermissonCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__